import Vue from "vue";
import VueRouter from "vue-router";
import store from "@/store/index.js";

import Home from "../views/Home";
import Wellcome from "../views/Wellcome";
import Beneficiarios from "../views/Beneficiarios/Consulta";
import BeneficiariosOspetax from "../views/Beneficiarios/ConsultaOspetax";
import ConsultaOrdenesOspetax from "../views/Beneficiarios/ConsultaOrdenesOspetax";
import ConsultaOrdenes from "../views/Beneficiarios/ConsultaOrdenes";

import Autogestion from "../views/Beneficiarios/Autogestion";
import RecuperarContrasena from "../views/Beneficiarios/RecuperarContrasena";
import PracticasAutogestion from "../views/Beneficiarios/Autogestion/Practicas";
import Misdatos from "../views/Beneficiarios/Autogestion/Misdatos";
import Credencial from "../views/Beneficiarios/Autogestion/Credencial";
import Cartilla from "../views/Cartilla";
import VerCartilla from "../views/VerCartilla";
import CartillaOseiv from "../views/CartillaOseiv";
import CartillaOspetax from "../views/CartillaOspetax";
import CartillaAutogestion from "../views/CartillaAutogestion";

import GrupoFamiliar from "../views/Beneficiarios/Autogestion/GrupoFamiliar";
import Micrositio from "../views/Efectores/Micrositio";
import AutorizacionesMicrositio from "../views/Efectores/Micrositio/Autorizaciones";
import DatosMicrositio from "../views/Efectores/Micrositio/Datos";
import AfiliacionMicrositio from "../views/Efectores/Micrositio/Afiliacion";
import Contacto from "../views/Efectores/Micrositio/Contacto";
import AuditoriaMedica from "../views/Bandejas/AuditoriaMedica";
import AtencionBeneficiario from "../views/Bandejas/AtencionBeneficiario";
import BandejaInternaciones from "../views/Bandejas/Internaciones";
import BandejaInternacionesOspetax from "../views/Bandejas/InternacionesOspetax.vue";

import ABMMotivos from "../views/ABMMotivos";
import Patologias from "../views/Patologias";
import PatologiasBeneficiarios from "../views/Beneficiarios/Patologias";
import PatologiasOspetax from "../views/Beneficiarios/PatologiasOspetax";

import ListaUltimasAutorizaciones from "../views/Bandejas/ListaUltimasAutorizaciones";
import ABMDiagnosticos from "../views/Diagnosticos";
import Reportes from "../views/Reportes";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home
  },
  {
    path: "/Wellcome",
    name: "Wellcome",
    component: Wellcome,
    meta: {
      requiresAuth: false
    }
  },
  {
    path: "/Beneficiarios",
    name: "Beneficiarios",
    component: Beneficiarios,
    meta: {
      requiresAuth: true,
      titulo: "BENEFICIARIOS"
    }
  },
  {
    path: "/BeneficiariosOspetax",
    name: "BeneficiariosOspetax",
    component: BeneficiariosOspetax,
    props: { id_area: 4 },
    meta: {
      requiresAuth: true,
      titulo: "AUTORIZACIONES - OSPETAX"
    }
  },
  {
    path: "/BeneficiariosOspical",
    name: "BeneficiariosOspical",
    component: BeneficiariosOspetax,
    props: { id_area: 5 },
    meta: {
      requiresAuth: true,
      titulo: "AUTORIZACIONES - OSPICAL"
    }
  },
  {
    path: "/ConsultaOrdenesOspetax",
    name: "ConsultaOrdenesOspetax",
    component: ConsultaOrdenesOspetax,
    props: { id_area: 4 },
    meta: {
      requiresAuth: true,
      titulo: "CONSULTA DE AUTORIZACIONES - OSPETAX"
    }
  },
  {
    path: "/ConsultaOrdenesOspical",
    name: "ConsultaOrdenesOspical",
    component: ConsultaOrdenesOspetax,
    props: { id_area: 5 },
    meta: {
      requiresAuth: true,
      titulo: "CONSULTA DE AUTORIZACIONES - OSPICAL"
    }
  },
  {
    path: "/ConsultaOrdenes",
    name: "ConsultaOrdenes",
    component: ConsultaOrdenes,
    meta: {
      requiresAuth: true,
      titulo: "CONSULTA DE AUTORIZACIONES"
    }
  },
  {
    path: "/Autogestion/RecuperarContrasena/:idafiliado/:token",
    name: "Recuperarcontrasena",
    component: RecuperarContrasena,
    meta: {
      requiresAuth: false,
      titulo: "RECUPERAR CONTRASEÑA"
    }
  },
  {
    path: "/Autogestionbeneficiarios/Practicas",
    name: "PracticasAutogestion",
    component: PracticasAutogestion,
    meta: {
      requiresAuth: false,
      titulo: "PRACTICAS"
    }
  },
  {
    path: "/Autogestionbeneficiarios/Misdatos",
    name: "Misdatos",
    component: Misdatos,
    meta: {
      requiresAuth: false,
      titulo: "MIS DATOS"
    }
  },
  {
    path: "/Autogestionbeneficiarios/Credencial",
    name: "Credencial",
    component: Credencial,
    meta: {
      requiresAuth: false,
      titulo: "CREDENCIAL"
    }
  },
  {
    path: "/Autogestionbeneficiarios/CartillaAutogestion",
    name: "CartillaAutogestion",
    component: CartillaAutogestion,
    meta: {
      requiresAuth: false,
      titulo: "CARTILLA"
    }
  },
  {
    path: "/Autogestionbeneficiarios/GrupoFamiliar",
    name: "GrupoFamiliar",
    component: GrupoFamiliar,
    meta: {
      requiresAuth: false,
      titulo: "GRUPO FAMILIAR"
    }
  },
  {
    path: "/vercartilla",
    name: "VerCartilla",
    component: VerCartilla,
    meta: {
      requiresAuth: false,
      titulo: "VER CARTILLA"
    }
  },
  {
    path: "/CartillaOseiv",
    name: "CartillaOseiv",
    component: CartillaOseiv,
    meta: {
      requiresAuth: false,
      titulo: "VER CARTILLA"
    }
  },
  {
    path: "/Autogestion",
    name: "Autogestion",
    component: Autogestion,
    meta: {
      requiresAuth: false,
      titulo: "AUTOGESTION"
    }
  },
  {
    path: "/Micrositio",
    name: "Micrositio",
    component: Micrositio,
    meta: {
      requiresAuth: false,
      titulo: "MICROSITIO DE PRESTADORES"
    }
  },
  {
    path: "/Micrositioprestadores/Autorizaciones",
    name: "AutorizacionesMicrositio",
    component: AutorizacionesMicrositio,
    meta: {
      requiresAuth: false,
      titulo: "AUTORIZACIONES"
    }
  },
  {
    path: "/Micrositioprestadores/DatosMicrositio",
    name: "DatosMicrositio",
    component: DatosMicrositio,
    meta: {
      requiresAuth: false,
      titulo: "MIS DATOS"
    }
  },
  {
    path: "/Reportes",
    name: "Reportes",
    component: Reportes,
    meta: {
      requiresAuth: true,
      titulo: "Reportes"
    }
  },
  {
    path: "/Micrositioprestadores/AfiliacionMicrositio",
    name: "AfiliacionMicrositio",
    component: AfiliacionMicrositio,
    meta: {
      requiresAuth: false,
      titulo: "CONSULTAR AFILIACION"
    }
  },
  {
    path: "/Micrositioprestadores/Contacto",
    name: "Contacto",
    component: Contacto,
    meta: {
      requiresAuth: false,
      titulo: "Contacto"
    }
  },
  {
    path: "/AtencionBeneficiario",
    name: "AtencionBeneficiario",
    component: AtencionBeneficiario,
    meta: {
      requiresAuth: true,
      titulo: "ATENCION AL BENEFICIARIO"
    }
  },
  {
    path: "/AuditoriaMedica",
    name: "AuditoriaMedica",
    component: AuditoriaMedica,
    meta: {
      requiresAuth: true,
      titulo: "AUDITORIA MEDICA"
    }
  },
  {
    path: "/BandejaInternaciones",
    name: "BandejaInternaciones",
    component: BandejaInternaciones,
    meta: {
      requiresAuth: true,
      titulo: "BANDEJA INTERNACIONES"
    }
  },
  {
    path: "/BandejaInternacionesOspetax",
    name: "BandejaInternacionesOspetax",
    component: BandejaInternacionesOspetax,
    props: { id_area: 4 },
    meta: {
      requiresAuth: true,
      titulo: "BANDEJA INTERNACIONES - OSPETAX"
    }
  },
  {
    path: "/BandejaInternacionesOspical",
    name: "BandejaInternacionesOspical",
    component: BandejaInternacionesOspetax,
    props: { id_area: 5 },
    meta: {
      requiresAuth: true,
      titulo: "BANDEJA INTERNACIONES - OSPICAL"
    }
  },
  {
    path: "/ListaUltimasAutorizaciones",
    name: "ListaUltimasAutorizaciones",
    component: ListaUltimasAutorizaciones,
    meta: {
      requiresAuth: true,
      titulo: "LISTADO DE ULTIMAS AUTORIZACIONES"
    }
  },
  {
    path: "/Cartilla",
    name: "Cartilla",
    component: Cartilla,
    meta: {
      requiresAuth: false,
      titulo: "CARTILLA"
    }
  },
  {
    path: "/CartillaOspetax",
    name: "CartillaOspetax",
    component: CartillaOspetax,
    meta: {
      requiresAuth: false,
      titulo: "CARTILLA OSPETAX"
    }
  },
  {
    path: "/CartillaOspical",
    name: "CartillaOspical",
    component: CartillaOspetax,
    meta: {
      requiresAuth: false,
      titulo: "CARTILLA OSPICAL"
    }
  },

  {
    path: "/Patologias",
    name: "Patologias",
    component: Patologias,
    meta: {
      requiresAuth: true,
      titulo: "PATOLOGIAS"
    }
  },
  {
    path: "/PatologiasBeneficiarios",
    name: "PatologiasBeneficiarios",
    component: PatologiasBeneficiarios,
    meta: {
      requiresAuth: true,
      titulo: "PATOLOGIAS BENEFICIARIOS"
    }
  },
  {
    path: "/PatologiasOspetax",
    name: "PatologiasOspetax",
    component: PatologiasOspetax,
    props: { id_area: 4 },
    meta: {
      requiresAuth: true,
      titulo: "PATOLOGIAS BENEFICIARIOS (OSPETAX)"
    }
  },
  {
    path: "/PatologiasOspical",
    name: "PatologiasOspical",
    component: PatologiasOspetax,
    props: { id_area: 5 },
    meta: {
      requiresAuth: true,
      titulo: "PATOLOGIAS BENEFICIARIOS (OSPICAL)"
    }
  },
  {
    path: "/ABMMotivos",
    name: "ABMMotivos",
    component: ABMMotivos,
    meta: {
      requiresAuth: true,
      titulo: "Motivos"
    }
  },
  {
    path: "/ABMDiagnosticos",
    name: "ABMDiagnosticos",
    component: ABMDiagnosticos,
    meta: {
      requiresAuth: true,
      titulo: "Diagnosticos"
    }
  }
];

const router = new VueRouter({
  routes
});

function tienePermiso(to) {
  let ret = true;
  if (to.meta.requiresAuth === false) {
    ret = true;
  } else {
    let Permisos = store.state.comun.Permisos;
    let permito = Permisos.find((x) => x.descripcion_permiso === to.name);
    ret = permito !== undefined;
  }
  return ret;
}

router.beforeEach((to, from, next) => {
  if (to.matched.some((record) => record.meta.requiresAuth)) {
    if (tienePermiso(to)) {
      next();
    } else {
      next("/");
    }
  } else {
    next();
  }
});

export default router;
